import { useSelector } from 'react-redux';
import { Button } from '@vinted/web-ui';
import HeaderLogo from 'components/HeaderLogo';
import useTranslate from 'hooks/useTranslate';
import { getUser } from 'state/session/selectors';
import { logoutUser } from 'data/api/account';
import { navigateToPage } from 'libs/utils/window';
import { ROOT_URL } from 'constants/routes';
import { useEmailCodeTest } from './hooks/useEmailCodeTest';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const HeaderNoNavigation = _ref => {
  let {
    portal
  } = _ref;
  const user = useSelector(getUser);
  const translate = useTranslate();
  const {
    trackLogoutEvent,
    isLoadingPrompts,
    trackEmailCodeSkipEvent,
    handleDismissVerificationPrompt
  } = useEmailCodeTest();

  const handleLogoutClick = async () => {
    const response = await logoutUser();

    if (response) {
      trackLogoutEvent();
      navigateToPage(ROOT_URL);
    }
  };

  const handleDismissPrompt = async () => {
    await handleDismissVerificationPrompt();
    navigateToPage(ROOT_URL);
  };

  const handleLogoClick = event => {
    event.preventDefault();
    trackEmailCodeSkipEvent();
    handleDismissPrompt();
    return false;
  };

  const renderLogo = () => {
    return /*#__PURE__*/_jsx(HeaderLogo, {
      portal: portal,
      onClick: handleLogoClick
    });
  };

  const renderLogoutButton = () => {
    if (!user) return null;
    return /*#__PURE__*/_jsx("div", {
      className: "l-header__actions",
      children: /*#__PURE__*/_jsx(Button, {
        theme: "muted",
        styling: Button.Styling.Flat,
        size: Button.Size.Medium,
        onClick: handleLogoutClick,
        disabled: isLoadingPrompts,
        children: translate('header.actions.log_out')
      })
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: "l-header",
    children: /*#__PURE__*/_jsx("header", {
      className: "l-header__main",
      children: /*#__PURE__*/_jsx("div", {
        className: "container u-flexbox u-align-items-center u-fill-height",
        children: /*#__PURE__*/_jsxs("div", {
          className: "l-header__content",
          children: [renderLogo(), renderLogoutButton()]
        })
      })
    })
  });
};

export default HeaderNoNavigation;